module.exports = "https://static.energy5.com/_next/static/images/installation-23bd4df2ef85514be116fb0fa75c754c.webp";